<template>
  <div>
    <card-banners-vue :pCardBannersValues="cardBannersValues"></card-banners-vue>
    <card-Metas-vue class="shadow" :pCardMetasValues="cardMetasValues" comissao="Comissão" :style1="cor"></card-Metas-vue>
    <!-- <card-pedidos-orcamento-vue class="mt-3 p-0 shadow" :pCardPedidosEmOrcamentoValues="cardPedidosEmOrcamentoValues" header="Orçamentos" :style1="cor"></card-pedidos-orcamento-vue> -->
    <BlockUI v-if="blockUI.blockUiVisibility" :message="blockUI.message">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import App from '@/App'
  import { broadcastServer } from '@/main'
  import CardMetasVue from '@/components/items/CardMetasVue'
  import CardPedidosOrcamentoVue from '@/components/items/CardPedidosOrcamentoVue'
  import ComunicadoVue from '@/components/items/ComunicadoVue'
  import CarouselVue from '@/components/items/CarouselVue'
  import CardPedidosObservacaoVue from '../components/items/CardPedidosObservacaoVue'
  import PromocoesVue from '../components/items/PromocoesVue'
  import CardNovidadesVue from '../components/items/cardNovidadesVue'
  import dashboard from '@/services/dashboard'
  import spinnerVue from '@/components/items/SpinnerVue'
  import CardBannersVue from '@/components/items/cardBannersVue'

  export default {
    name: 'Home',
    components: {
      CardNovidadesVue,
      CardPedidosObservacaoVue,
      App,
      CardMetasVue,
      ComunicadoVue,
      CarouselVue,
      CardPedidosOrcamentoVue,
      spinnerVue,
      PromocoesVue,
      CardBannersVue
    },
    data () {
      return {
        cor: '',
        blockUI: {
          message: '',
          blockUiVisibility: false
        },
        cardMetasValues: {
          valorMeta: 0.00,
          valorAtingido: 0.00,
          periodo: ''
        },
        cardPedidosEmOrcamentoValues: {pedidos: []},
        cardNovidadesValues: {destaques: []},
        cardPedidosEmObservacaoValues: {duplicatas: []},
        cardBannersValues: {banners: []}
      }
    },
    created: function () {
      window.addEventListener('beforeunload', this.toTopOnRefresh)
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      this.corComp = {'style: background-color': `#${localStorage.getItem('corApp')}`}
      // console.log('home criado')
      broadcastServer.$on('emitBuscaDadosDashboard', parametro => {
        this.buscaDadosDashboard()
      })
    },
    mounted () {
      this.buscaDadosDashboard()
    },
    methods: {
      toTopOnRefresh: function toTopOnRefresh (event) {
        window.scrollTo(0, 0)
      },
      buscaDadosDashboard: function () {
        this.blockUI.blockUiVisibility = true
        this.blockUI.message = 'Atualizando Dashboard, aguarde...'
        dashboard.listarDashboard().then(response => {
          // card metas
          this.cardMetasValues = {
            valorMeta: response.data.meta.valorMeta,
            valorAtingido: response.data.atingido.valorAtingido,
            periodo: response.data.comissao.periodo
          }
          // card pedidos em orcamento
          this.cardPedidosEmOrcamentoValues.pedidos = response.data.pedidosEmOrcamento.sort(function (a, b) {
            return b.id - a.id
          })
          // car novidades
          this.cardNovidadesValues.destaques = response.data.destaques
          // card pedidos Observacao
          this.cardPedidosEmObservacaoValues.duplicatas = response.data.duplicatas.sort(function (a, b) {
            return b.diasAtraso - a.diasAtraso
          })
          this.cardBannersValues.banners = response.data.banners.sort(function (a, b) {
            return a.ordem - b.ordem
          })
        }).catch(error => {
          console.log(error)
          this.showMessage('Erro ao obter dados do dashboard!\n' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.blockUiVisibility = false
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/HomeVue.vue